import { useEffect, useState } from "react";

const useResize = () => {
  const [height, setHeight] = useState(400);
  useEffect(() => {
    let isDragging = false;
    let startY = 0;
    let startHeight = height;

    const onMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;
      const diff = e.clientY - startY;
      const newHeight = Math.max(100, startHeight + diff);
      setHeight(newHeight);
    };

    const onMouseUp = () => {
      isDragging = false;
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    const onMouseDown = (e: React.MouseEvent) => {
      isDragging = true;
      startY = e.clientY;
      startHeight = height;
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    };

    const bar = document.getElementById("resize-bar");
    if (bar) {
      bar.addEventListener("mousedown", onMouseDown as any);
    }

    return () => {
      if (bar) bar.removeEventListener("mousedown", onMouseDown as any);
    };
  }, [height]);
  return { height };
};
export { useResize };
